import React, { useState, useEffect } from 'react';
import '../Components/CSS/Global.css';

const features = [
    { id: 1, name: "Product Management", price: 100 },
    { id: 2, name: "User Account Management", price: 50 },
    { id: 3, name: "Shopping Cart", price: 75 },
    { id: 4, name: "Secure Checkout", price: 120 },
    { id: 5, name: "Order Tracking", price: 60 },
    { id: 6, name: "Wishlist", price: 40 },
    { id: 7, name: "Product Reviews & Ratings", price: 30 },
    { id: 8, name: "Inventory Management", price: 90 },
    { id: 9, name: "Discount Coupons", price: 35 },
    { id: 10, name: "Advanced Search & Filtering", price: 80 },
];

const EcommercePricing = () => {
    const [selectedFeatures, setSelectedFeatures] = useState([]);

    useEffect(() => {
        const savedFeatures = JSON.parse(localStorage.getItem("selectedFeatures")) || [];
        setSelectedFeatures(savedFeatures);
    }, []);

    useEffect(() => {
        localStorage.setItem("selectedFeatures", JSON.stringify(selectedFeatures));
    }, [selectedFeatures]);

    const toggleFeature = (feature) => {
        setSelectedFeatures(prevSelected => {
            if (prevSelected.includes(feature.id)) {
                return prevSelected.filter(id => id !== feature.id);
            } else {
                return [...prevSelected, feature.id];
            }
        });
    };

    const totalAmount = selectedFeatures.reduce((total, featureId) => {
        const feature = features.find(f => f.id === featureId);
        return total + (feature ? feature.price : 0);
    }, 0);

    return (
        <>
            <div className="pricing">
                <h2>Select Services</h2>
                {features.map(feature => (
                    <div key={feature.id} className="pricing-list">
                        <div className="price-title">
                            {feature.name}
                        </div>
                        <div className="price-toggle-container">
                            <div className="price-amount">
                                ₹{feature.price}
                            </div>
                            <div className="toggle-container">
                                <label className="switch">
                                    <input 
                                        type="checkbox" 
                                        checked={selectedFeatures.includes(feature.id)} 
                                        onChange={() => toggleFeature(feature)} 
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="pricing-total">
                <h2>Total: ₹{totalAmount}</h2>
                <button>Proceed</button>
            </div>
        </>
    );
};

export default EcommercePricing;
